import { render, staticRenderFns } from "./PriceInformations.vue?vue&type=template&id=5c5783b8&scoped=true"
import script from "./PriceInformations.vue?vue&type=script&lang=js"
export * from "./PriceInformations.vue?vue&type=script&lang=js"
import style0 from "./PriceInformations.vue?vue&type=style&index=0&id=5c5783b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5783b8",
  null
  
)

export default component.exports